export const guestInfo = [
    {
    "Name": "Jone Liya",
    "Room No": "102",
    "Booking No": "11580",
    "Email ID": "joneliya@gmail.com",
    "Mobile No": "+22 202-302-4586",
    "Address": "Low FG, Fat Road",
    "Time Format": "24HRS"
    }
]

export const roomInfo = [
    {
    "Room Rent Amt": "$800",
    "Discount Amt": "$0",
    "Service Charge Amt": "$56",
    "Total Room Rent Amt": "$856",
    "Room Amt With Tax": "$972",
    "Advance Amt": "$0",
    "Payable Rent Amt": "$972"
    }
]

  